var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',[_c('v-col',{attrs:{"cols":"4"}},[_c('payfast-transitioned-subscriptions')],1),_c('v-col',{attrs:{"cols":"4"}},[_c('chats-inactive-staff')],1),_c('v-col',{attrs:{"cols":"4"}},[_c('clients-without-support-owner')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }